export default "__VITE_ASSET__DzM500Xh__"